import { TTheme } from '@rbx/ui';

export const appBannerClassName = 'banner';
export const topNavQuerySelector = '#__next > header > nav';
export const topNavRightContentID = 'top-nav-right';
export const secondaryNavID = 'secondary-nav';
export const mainLayoutID = 'main-container';
export const mainID = 'main';
export const leftNavID = 'left-nav';
export const rightNavID = 'right-nav';
export const footerID = 'footer';
export const topNavigationHeight = 60;
export const thinScrollbarGutterWidth = 7;
export const leftNavWidth = 300;
export const rightNavWidth = 257;
export const rightNavPaddingX = 40;
export const rightNavPaddingXSmallMedium = 24;
export const landingPageMaxWidth = 1920;
export const nonLandingPageMaxWidth = 1280;

export const showSecondaryNavigationMinBreakpoint = 'Large';

const spacingUnit = 8; // pixels per spacing unit

const appMainSpacingTop = {
  default: 6,
  lg: 6,
  md: 3,
};
export const appMain = {
  maxWidth: 1280,
  articleMaxWidth: 912, // for markdown pages with a right nav
  spacingTop: appMainSpacingTop,
  spacing: {
    default: [appMainSpacingTop.default, 4, 4, 4],
    lg: [appMainSpacingTop.lg, 4, 4, 4],
    md: [appMainSpacingTop.md, 3, 3, 3],
  } as Record<string, Parameters<TTheme['spacing']>>,
};

// main width is the same as the main width's max width, at >=
// MainWidthForCenterContentXL breakpoint
export const getMainWidthForCenterContentXL = (mainMaxWidth: number) =>
  ((appMain.spacing.default[1] as number) + (appMain.spacing.default[3] as number)) * spacingUnit +
  mainMaxWidth;

// the min width at which the page starts to add empty space between elements
export const getXLBreakpoint = (mainMaxWidth: number) =>
  leftNavWidth + getMainWidthForCenterContentXL(mainMaxWidth) + rightNavWidth;

// the media query needed to start applying absolute page content centering styles,
// instead of left flanking content on a small enough screen
export const getXLCenterContentMediaQuery = (mainMaxWidth: number) =>
  `@media (min-width: ${getXLBreakpoint(mainMaxWidth)}px)`;

// TODO: fix needed hack of secondaryNavigationHeight
export const secondaryNavigationHeight = 50;
export const rightNavMinBreakpoint = 'Large';
export const collapsedLeftNavWidth = 48;
export const minSpecBannerHeight = 48;

export const htmlThemeAttribute = 'color-scheme';

export default {
  mainLayoutID,
  topNavigationHeight,
  secondaryNavigationHeight,
  rightNavMinBreakpoint,
  rightNavWidth,
};

export const darkTypographyColor = '#BBBCBE';
export const lightTypographyColor = '#696A6D';

// markdown file content should have this custom font size on all standard text components.
// Get custom markdown font size based on whether engine revamp is enabled
export const getCustomMarkdownFontSize = (enableEngineReferenceRevamp: boolean) =>
  enableEngineReferenceRevamp ? '16px' : '18px';

export const getCustomInlineCodeFontSize = (enableEngineReferenceRevamp: boolean) =>
  enableEngineReferenceRevamp ? '14px' : '16px';

export const getAppMainTop = (showSecondaryNavigation: boolean, showMinSpecBanner = false) =>
  topNavigationHeight +
  (showSecondaryNavigation ? secondaryNavigationHeight : 0) +
  (showMinSpecBanner ? minSpecBannerHeight : 0);

export const getAppMainHeight = (showSecondaryNavigation: boolean, showMinSpecBanner = false) =>
  `calc(100vh - ${getAppMainTop(showSecondaryNavigation, showMinSpecBanner)}px)`;
